"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerConfig = void 0;
var advertising_1 = require("./advertising");
var captions_1 = require("./captions");
var logo_1 = require("./logo");
var skin_1 = require("./skin");
var nicam_icons_1 = require("./nicam-icons");
var sharing_1 = require("./sharing");
var endCard_1 = require("./endCard");
var fullEpisodeButton_1 = require("./fullEpisodeButton");
var PlayerConfig = (function () {
    function PlayerConfig(clientConfig, apiConfig) {
        var _this = this;
        var _a, _b, _c, _d;
        this.advertising = null;
        this.sharing = null;
        this.playlist = [];
        this.referrers = [];
        this.cast = null;
        if (!apiConfig.playerProvider || !apiConfig.playerProvider.key) {
            throw new Error('Missing JW key in API config');
        }
        this.key = apiConfig.playerProvider.key;
        this.slug = apiConfig.slug;
        if (apiConfig.advertising) {
            this.advertising = new advertising_1.Advertising(apiConfig.advertising, clientConfig);
        }
        if (apiConfig.referrers) {
            this.referrers = apiConfig.referrers;
        }
        this.logo = new logo_1.Logo(clientConfig, (_a = apiConfig.skin) === null || _a === void 0 ? void 0 : _a.logo);
        this.skin = new skin_1.Skin(clientConfig.skin, apiConfig.skin);
        this.captions = new captions_1.Captions((_b = apiConfig.skin) === null || _b === void 0 ? void 0 : _b.captions);
        this.nicamIcons = new nicam_icons_1.NicamIcons(clientConfig.nicamKijkwijzerConfig, (_c = apiConfig.skin) === null || _c === void 0 ? void 0 : _c.nicamKijkwijzerConfig);
        if (apiConfig.sharing) {
            this.sharing = new sharing_1.Sharing(apiConfig.sharing, this.referrers, clientConfig.shareLink);
        }
        this.endCard = new endCard_1.EndCard(clientConfig.endCard, apiConfig.endCard);
        this.fullEpisodeButton = new fullEpisodeButton_1.FullEpisodeButton(clientConfig.fullEpisodeButton, apiConfig.fullEpisodeButton);
        this.adobeDelay = clientConfig.adobeDelay || apiConfig.adobeDelay || false;
        this.localization = {
            related: {
                heading: 'Meer videos',
            },
        };
        var apiPlaybackOptions = apiConfig.playbackOptions || [];
        var autostart = apiPlaybackOptions.includes('Autoplay');
        var mute = apiPlaybackOptions.includes('Mute');
        var repeat = apiPlaybackOptions.includes('Repeat');
        var preload = apiPlaybackOptions.includes('Preload');
        var playbackRateControls = apiPlaybackOptions.includes('Playback-Rate-Controls');
        var apiDisplayOptions = ((_d = apiConfig.skin) === null || _d === void 0 ? void 0 : _d.displayOptions) || [];
        var controls = apiDisplayOptions.includes('Display-Controls');
        var displaytitle = apiDisplayOptions.includes('Display-Title');
        var displaydescription = apiDisplayOptions.includes('Display-Description');
        this.aspectratio = '';
        this.autostart = autostart ? 'viewable' : false;
        this.controls = controls;
        this.displaydescription = displaydescription;
        this.displaytitle = displaytitle;
        this.height = '500px';
        this.mute = mute;
        this.playbackRateControls = playbackRateControls;
        this.preload = preload ? 'auto' : 'none';
        this.repeat = repeat;
        this.width = '100%';
        var clientPlaybackOptions = clientConfig.playbackOptions;
        if (clientPlaybackOptions) {
            Object.keys(clientPlaybackOptions).forEach(function (key) {
                if (key === 'start')
                    return;
                if (key === 'stop')
                    return;
                if (typeof _this[key] === 'undefined') {
                    console.warn("Invalid playback option \"".concat(key, "\""));
                    return;
                }
                if (key === 'autostart') {
                    _this.autostart = clientPlaybackOptions[key] ? 'viewable' : false;
                    return;
                }
                _this[key] = clientPlaybackOptions[key];
            });
        }
    }
    return PlayerConfig;
}());
exports.PlayerConfig = PlayerConfig;
